/* eslint-disable no-console */
import axios from 'axios';

// import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import {STRATEGY_BASE_URL} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import useJSONStore from '../../../store/StaticJson/jsonStore';
import useUserStore from '../../../store/userStore/userStore';
import {hasUserRole, UserRole} from '../../../utils/commonFunctions';

const stackHolderTypeJson = async (): Promise<any> => {
  const token = useUserStore.getState().userToken;
  const setStackHolderType = useJSONStore.getState().setStackHolderType;

  await axios
    .request({
      method: CRUDMethods.GET,
      // url: `${API_BASE_URL}${API_ENDPOINT_JSON.JSON.supplierType}`,
      url: `${STRATEGY_BASE_URL}/dropdown/stakeholdersType`,
      headers: {
        Authorization: `Bearer ${token}`
      },
      params: {},
      data: {}
    })
    .then((res) => {
      setStackHolderType(
        res.data.data.filter((item: any) => {
          return hasUserRole(UserRole.Company_Admin) ||
            hasUserRole(UserRole.Company_user)
            ? true
            : item.value !== 'External';
        })
      );
    })
    .catch((err) => {
      return err.message;
    });
};

export default stackHolderTypeJson;
